const namespaced = true

const state = {

    currentLanguage: 'de',
    wordings: {
        'de': {
            'FAVS': 'Favoriten',
            'NOTES': 'Notizen',
            'MY_NOTE': 'Meine Notiz',
            'PRESENTATION': 'Präsentation',
            'MAIL_EXPORT': 'In Mail exportieren',
            'CHAIR_HEADER': 'Chair',
            'SPEAKER_HEADER': 'Presenter',
            'PRESENTATION_HEADER': 'Presentations',
                     'CHAIR_HEADER': 'Moderation',
            'SPEAKER_HEADER': 'Speaker',
            'PRESENTATION_HEADER': 'Présentation',
            'PERSON_SESSION_HEADER': 'Séances de cette personne',
            'PERSON_SESSION_HEADER': 'Sessions of this Person',
            'LOGIN': 'Einloggen',
            'IMPRINT': 'Impressum',
            'ABOUT': 'Über',
            'PRIVACY': 'Datenschutz',
            'SUPPORT': 'Support',
            'SEARCH': 'Suche',
            'ADD_FAVORITE': 'Favorit',
            'RM_FAVORITE': 'Favorit',
            'SAVE_CALENDAR': 'Im Kalender speichern',
            'CHAIR_HEADER': 'Moderation',
            'SPEAKER_HEADER': 'Referent:innen',
            'PRESENTATION_HEADER': 'Präsentationen',
            'INTERACTIVE_HEADER': 'Q&A',
            'PERSON_SESSION_HEADER': 'Sitzungen dieser Person',
            'EVALUATE': 'Bewerten',
            'SESSION_HEADER': 'Sitzung',
            'SESSION_HEADER_ALSO': 'Auch hier präsentiert',
            'NOW_HINT': 'Es laufen zur Zeit keine Sitzungen',
            'SESSIONS_EMPTY_TITLE': 'Keine Live-Sitzungen',
            'SESSIONS_EMPTY_TEXT': 'Derzeit laufen keine Sitzungen oder beginnen in den nächsten 15 Minuten. Bitte schauen Sie später vorbei oder sehen Sie sich das vollständige Programm an.',
            'SESSIONS_EMPTY_HINT': 'Nach unten ziehen, um zu aktualisieren oder das Programm zu überprüfen',
            'GO_TO_PROGRAM': 'Vollständiges Programm anzeigen',
            'FAVORITES_EMPTY_TITLE': 'Noch keine Favoriten',
            'FAVORITES_EMPTY_TEXT': 'Sie haben bisher keine Favoriten hinzugefügt. Sie können Sitzungen, Präsentationen, Personen und Unternehmen zu Ihren Favoriten hinzufügen.',
            'FAVORITES_EMPTY_HINT': 'Suchen Sie nach dem Herz-Symbol, um Elemente zu Ihren Favoriten hinzuzufügen',
            'NOTES_EMPTY_TITLE': 'Noch keine Notizen',
            'NOTES_EMPTY_TEXT': 'Sie haben bisher keine Notizen hinzugefügt. Sie können Notizen zu Sitzungen, Präsentationen, Personen und Unternehmen hinzufügen.',
            'NOTES_EMPTY_HINT': 'Suchen Sie nach dem Notiz-Symbol, um persönliche Notizen zu Elementen hinzuzufügen',
            'SESSION_TYPES_TITLE': 'Sitzungsarten',
            'SESSION_TYPES_SUBTITLE': 'Entdecken Sie verschiedene Arten von verfügbaren Sitzungen',
            'SESSION_TYPES_EMPTY_TITLE': 'Keine Sitzungsarten verfügbar',
            'SESSION_TYPES_EMPTY_TEXT': 'Derzeit gibt es keine Sitzungsarten anzuzeigen.',
            'SESSION_THEMES_TITLE': 'Sitzungsthemen',
            'SESSION_THEMES_SUBTITLE': 'Entdecken Sie verschiedene Themen',
            'SESSION_THEMES_EMPTY_TITLE': 'Keine Themen verfügbar',
            'SESSION_THEMES_EMPTY_TEXT': 'Derzeit gibt es keine Themen anzuzeigen.',
            'MAPS_TITLE': 'Karten & Grundrisse',
            'MAPS_SUBTITLE': 'Navigieren Sie einfach durch den Veranstaltungsort',
            'MAPS_EMPTY_TITLE': 'Keine Karten verfügbar',
            'MAPS_EMPTY_TEXT': 'Es sind derzeit keine Karten oder Grundrisse anzuzeigen.',
            'MAPS_EMPTY_HINT': 'Karten werden hinzugefügt, sobald sie verfügbar sind',
            'VIEW_MAP': 'Karte anzeigen',
            'SESSION_FILTER_NO_RESULTS_TITLE': 'Keine Sitzungen gefunden',
            'SESSION_FILTER_NO_MATCHES_TITLE': 'Keine Sitzungen entsprechen Ihren Filtern',
            'SESSION_FILTER_SEARCH_TEXT': 'Wir konnten keine Sitzungen finden, die zu Ihrer Suche passen',
            'SESSION_FILTER_FILTER_TEXT': 'Versuchen Sie, Ihre Filterauswahl anzupassen, um mehr Sitzungen zu sehen.',
            'SESSION_FILTER_SEARCH_HINT': 'Versuchen Sie einen anderen Suchbegriff oder entfernen Sie Filter',
            'SESSION_FILTER_COUNT_HINT': 'Sitzungstyp derzeit herausgefiltert',
            'SESSION_FILTER_COUNT_HINT_PLURAL': 'Sitzungstypen derzeit herausgefiltert',
            'PERSONS_NO_RESULTS_TITLE': 'Keine Personen gefunden',
            'PERSONS_NO_MATCHES_TITLE': 'Keine Personen für diesen Buchstaben',
            'PERSONS_SEARCH_TEXT': 'Wir konnten keine Personen finden, die zu Ihrer Suche passen',
            'PERSONS_LETTER_TEXT': 'Es gibt keine Personen, deren Namen mit diesem Buchstaben beginnen.',
            'PERSONS_SEARCH_HINT': 'Versuchen Sie einen anderen Suchbegriff',
            'PERSONS_LETTER_HINT': 'Wählen Sie einen anderen Buchstaben oder suchen Sie nach einem bestimmten Namen',
            'SPONSORS_NO_RESULTS_TITLE': 'Keine Sponsoren gefunden',
            'SPONSORS_SEARCH_TEXT': 'Wir konnten keine Sponsoren finden, die zu Ihrer Suche passen',
            'SPONSORS_SEARCH_HINT': 'Versuchen Sie einen anderen Suchbegriff oder überprüfen Sie die Schreibweise',
            'EXHIBITORS_NO_RESULTS_TITLE': 'Keine Aussteller gefunden',
            'EXHIBITORS_SEARCH_TEXT': 'Wir konnten keine Aussteller finden, die zu Ihrer Suche passen',
            'EXHIBITORS_SEARCH_HINT': 'Versuchen Sie einen anderen Suchbegriff oder überprüfen Sie die Schreibweise',
            'CLEAR_FILTERS': 'Filter löschen',
            'SORT_BY_BOOTH': 'Nach Stand sortieren',
            'SORT_ALPHABETICALLY': 'Alphabetisch sortieren',
            'SESSION': 'Sitzung',
            'SESSIONS': 'Sitzungen',
            'SECTION_SESSION': 'Sitzungen',
            'SECTION_PRESENTATION': 'Präsentationen',
            'SECTION_PERSON': 'Personen',
            'SECTION_ABSTRACTS': 'Abstracts',
            'SECTION_INDUSTRY': 'Aussteller',
            'NEWS_HINT': 'Zur Zeit gibt es keine Nachrichten',
            'COMMENTS': 'Kommentare',
            'INTERACTIVE': 'Fragen',
            'NO_RESULT_FIRST': 'Es konnte kein Eintrag zu Ihrer Suche nach "',
            'NO_RESULT_SECOND': '" gefunden werden. Bitte versuchen Sie einen anderen Begriff.',
            'SEARCH_START_TITLE': 'Suche starten',
            'SEARCH_START_TEXT': 'Geben Sie oben einen Suchbegriff ein, um Sitzungen, Präsentationen, Personen, Abstracts und Brancheninhalte zu finden.',
            'SEARCH_START_HINT': 'Versuchen Sie, nach Themen, Referentennamen oder Firmennamen zu suchen',
            'SEARCH_NO_RESULTS_TITLE': 'Keine Ergebnisse gefunden',
            'SEARCH_NO_RESULTS_HINT': 'Versuchen Sie es mit anderen Schlüsselwörtern oder überprüfen Sie Ihre Rechtschreibung',
            'LOAD_COMMENTS': 'Kommentare werden geladen',
            'ENTER_COMMENT': 'Geben Sie Ihren Kommentar ein',
            'NO_FORUM': 'Es gibt noch keine Kommentare',
            'FORUM_LOGIN': 'Bitte loggen Sie sich ein, um Kommentare zu senden',
            'FORUM_SEND': 'Senden',
            'VOTING_LOGIN': 'Bitte melden Sie sich an, um an der Abstimmung teilzunehmen',
            'VOTING_CONTROVERSIAL': 'Kontrovers-Frage',
            'VOTE_ALREADY_SENT': 'Sie haben bereits abgestimmt',
            'VOTE_THANK': 'Vielen Dank für Ihre Abstimmung',
            'TOTAL_VOTES': 'Abstimmungen gesamt',
            'MY_QUESTION': 'Meine Frage',
            'ENTER_QUESTION': 'Geben Sie hier Ihre Frage ein',
            'QUESTION_SEND': ' Senden',
            'SEND_AS': 'Senden als ',
            'QUESTIONS_AUDIENCE': 'Fragen vom Publikum',
            'DATA_UPDATE': 'Aktualisieren',
            'PERSONAL_ACCOUNT': 'Mein Account',
            'ACCOUNT_EDIT': 'Profil bearbeiten',
            'ACCOUNT_EMAIL': 'Email',
            'ACCOUNT_PHONE': 'Telefon',
            'PHONE_NOT_SHARED': 'nicht geteilt',
            'ACCOUNT_ADDRESS': 'Adresse',
            'ACCOUNT_COUNTRY': 'Land',
            'ACCOUNT_RESET': 'Anwendung zurücksetzen',
            'RESET_HEADER': 'Anwendung zurücksetzen',
            'RESET_TEXT': 'Hiermit setzen Sie die Daten der Anwendung zurück. Sind Sie sich sicher?',
            'MY_PROFILE': 'Mein Profil',
            'MY_CONGRESS': 'Mein Kongress',
            'LOGOUT': 'Ausloggen',
            'CONTACT_US': 'Kontaktieren Sie uns',
            'VISIT_BOOTH': 'Besuchen Sie unseren Stand',
            'ABOUT_US': 'Über uns',
            'RES_CENTRE': 'Ressourcenzentrum',
            'EXHIBITORS': 'Ausstellungen',
            'NO_BIOGRAPHY': 'Diese Person hat keine Biografie',
            'ADD_NOTE': ' Notiz',
            'EDIT_NOTE': 'Notiz',
            'DELETE_NOTE': ' Löschen',
            'SAVE_NOTE': 'Notiz speichern',
            'CLOSE': 'Schließen',
            'ALL': 'Alle',
            'RECOMMENDATION_REASON_TITLE': 'Empfehlungssystem',
            'RECOMMENDATION_REASON_SESSION': 'Sitzungen werden basierend auf Ihren Favoriten empfohlen.',
            'BOOTHS': 'Stand',
            'NO_BOOTHS': 'Dieser Sponsor hat keine Stände',
            'WEBSITE': 'Website',
            'SPECIAL_THANKS': 'Besonderer Dank',
            'NO_NEWS': 'Im Moment gibt es noch keine Nachrichten.',
            'NEWS_EMPTY_TITLE': 'Keine Nachrichten verfügbar',
            'NEWS_EMPTY_TEXT': 'Derzeit gibt es keine Nachrichten-Updates oder Ankündigungen anzuzeigen. Schauen Sie später für die neuesten Informationen vorbei.',
            'NEWS_EMPTY_HINT': 'Nach unten ziehen, um zu aktualisieren und nach neuen Updates zu suchen',
            'COMING_SOON_TITLE': 'Demnächst verfügbar',
            'COMING_SOON_TEXT': 'Neue Inhalte werden hier bald verfügbar sein.',
            'COMING_SOON_HINT': 'Schauen Sie später für Updates vorbei!',
            'SHOW_MAP': 'Ort',
            'SESSION_NO_ACCESS': 'Ihre Registrierung beinhaltet keinen Zugriff auf diesen Inhalt.',
            'EVALUATION_NOT_ACTIVE': 'Die Bewertung ist für diese Sitzung nicht aktiv',
            'PRESENTATION_ABSTRACT': 'Abstract',
            'MORE_INFORMATION': 'Weitere Informationen',
            'INITIALIZING_DATA': 'Daten initialisieren',
            'CHECKING_DATA': 'Daten prüfen',
            'DELETE_ACCOUNT': 'Mein Konto löschen',
            'PERS_ACCOUNT': 'Persönliches Konto',
            'EXHIBITOR_WEBSITE': 'Besuche unsere Webseite',
            'DOWNLOAD': 'Lade herunter',
            'CALENDAR_SAVE': 'Sitzung erfolgreich gespeichert',
            'CALENDAR_SAVE_ERROR': 'Die Sitzung wurde nicht gespeichert. Fehler:',
            'SCANS_TITLE': 'Gescannte Sitzungen',
            'PERSON_SESSIONS_TITLE': 'Beteiligt an diesen Sitzungen',
            'PERSON_PRESENTATIONS_TITLE': 'Beteiligt an diesen Präsentationen',
            'TYPE_MESSAGE': 'Schreiben Sie Ihre Nachricht',
            'OPEN_DESCRIPTION': 'Beschreibung lesen',
            'SESSION_DESCRIPTION': 'Sitzungsbeschreibung',
            'ROOM_NO_ACCESS': 'Ihre Registrierung beinhaltet keinen Zugriff auf diese Inhalte.',
            'QANDA_RELOAD_AUDIO': 'Wenn Sie ein Echo hören oder den Stream oder die Q&A nicht sehen können, aktualisieren Sie bitte diese Seite.',
            'QANDA_RELOAD_VIDEO': 'Wenn Sie den Stream nicht sehen können, aktualisieren Sie bitte diese Seite.',
            'STREAM_START_SOON': 'Programm startet in Kürze',
            'TAB_DETAILS': 'Details',
            'TAB_SPEAKERS': 'Referent:innen',
            'TAB_PRESENTATIONS': 'Präsentationen',
            'NO_ADDITIONAL_DETAILS': 'Keine weiteren Details verfügbar',
            'CHAT_PARTICIPANTS': 'Teilnehmer:innen',
            'CHAT_MY_CHATS': 'Meine Chats',
            'CHAT_RECOMMENDATIONS': 'Networking Empfehlungen',
            'LEADS_MY_LEADS': 'Meine Kontakte',
            'MEETINGS_MY_MEETINGS': 'Meine Meetings',
            'CHATS_LOADING': 'Chats Laden...',
            'FAVORITES_SYNC': 'Favoriten Sync...',
            'LOG_IN_QUESTION': 'Möchten Sie sich anmelden?',
            'LOG_OUT_QUESTION': 'Möchten Sie sich abmelden?',
            'YES_ANSWER': 'Ja',
            'NO_ANSWER': 'Nein',
            'START_CHAT': 'Chat',
            'RECOMMENDATIONS': 'Empfehlungen',
            'SESSION_RECOMMENDATIONS': 'Sitzung Empfehlungen',

            'RECOMMENDATIONS_POPUP': 'Diese Sitzung wird Ihnen auf Basis folgender Kriterien angezeigt: ',
            'RECOMMENDATIONS_USER_POPUP': 'Dieses User wird Ihnen auf Basis folgender Kriterien angezeigt: ',
            'RECOMMENDATIONS_LOGIN': 'Bitte melden Sie sich an, um empfohlene Sitzungen basierend auf Ihrem Profil anzuzeigen.',
            'RECOMMENDED_FOR': 'Empfohlen für:',
            'SCHEDULE_MEETING_BUTTON': 'Meeting planen',
            'NETWORKING_SCHEDULE_BUTTON': 'Planen',
            'NETWORKING_SHARE_CONTACT_BUTTON': 'Kontakt teilen',
            'QR_CODE_TITLE': 'QR-Code klicken oder scannen',
            'QR_CODE_SUBTITLE': 'Zu Kontakten hinzufügen',
            'SAVE_CONTACT_BUTTON': 'Als Kontakt speichern',
            'SAVE_CONTACT_SUCCESS': 'Der Kontakt wurde auf Ihrem Gerät gespeichert',
            'COMPLETE_MEETING_REQUEST': 'Bitte füllen Sie alle Felder der Anfrage aus',
            'SHARE_PROFILE': 'Kontaktdaten Teilen',
            'SHARE_PROFILE_WITH': 'Kontaktdaten teilen mit ',
            'SHARE_PROFILE_DESCRIPTION': 'Durch die Nutzung dieser Funktion teilen Sie Ihre Kontaktdaten mit ',
            'SHARE_PROFILE_PROMPT': 'Geben oder bearbeiten Sie hier Ihre Kontaktdaten ein: ',
            'YOUR_PROFILE': 'Ihr Profil',
            'SHARING_WITH': 'Teilen mit',
            'ROOM_NOT_LINKED_TITLE': 'Raum nicht verknüpft',
            'ROOM_NOT_LINKED_TEXT': 'Dieser Raum ist derzeit nicht mit dem Grundriss verknüpft.',
            'ROOM_NOT_LINKED_HINT': 'Bitte versuchen Sie es später erneut oder wählen Sie einen anderen Raum.',
            'NO_RECOMMENDATIONS': 'Aktualisieren Sie Ihre Profilinformationen, um Empfehlungen zu erhalten',
            'LOGIN_REQUIRED': 'Anmeldung erforderlich',
            'LOGIN_REQUIRED_MSG': 'Für die meisten Funktionen dieser App ist eine Anmeldung erforderlich',
            'AUTHENTICATION_REQUIRED': 'Authentifizierung erforderlich',
            'LOGIN_HINT': 'Sie müssen angemeldet sein, um auf die Social Wall zuzugreifen',
            'SOCIAL_WALL': 'Social Wall',
            'SOCIAL_WALL_LOGIN_HINT': 'Melden Sie sich an, um auf die Social-Wall-Funktionen in dieser App zuzugreifen!',
            'NEW_MEETING_REQUEST': 'Neue Tregganfrage von',
            'DATE_MEETING_REQUEST': 'Datum',
            'LOCATION_MEETING_REQUEST': 'Standort',
            'SUBJECT_MEETING_REQUEST': 'Thema',
                        'DETAILS_MEETING_REQUEST': 'Details',
            'MORE_INFORMATION': 'Beschreibung',
            'SYNC_HEADER': 'Zusätzliche Daten verfügbar zum Download',
            'SYNC_MESSAGE': 'Möchten Sie {size} {unit} zusätzliche Daten laden?',
            'SYNC_UNPACK_HEADER': 'Zusätzliche Daten müssen entpackt werden',
            'SYNC_UNPACK_MESSAGE': 'Klicken Sie OK, um {size} {unit} zusätzliche Daten zu entpacken',
            'CANCEL': 'Abbrechen',
            'OK': 'OK',
            'QR_SHARE_PROFILE': 'Profil teilen',
            'QR_SHARE_PROFILE_SUBTITLE': 'Andere können Ihren QR-Code scannen, um Ihr Profil in der App zu sehen',
            'UP_TO_DATE': 'Ihre App ist auf dem neuesten Stand',
            'NEW_VERSION_AVAILABLE': 'Eine neue Version ist verfügbar',
            'NEW_VERSION_IN_STORE': 'Eine neue Version ist im App Store verfügbar',
            'LEAVE_CHAT_HEADER': 'Chat verlassen',
            'LEAVE_CHAT_MESSAGE': 'Durch das Verlassen des Chats sind Sie für andere Teilnehmer nicht mehr sichtbar. Alle Ihre Chats, geteilten Kontakte und Meetings werden gelöscht (für Sie und Ihre Chat-Partner). Sie können dem Chat zu einem späteren Zeitpunkt wieder beitreten, aber die Informationen werden nicht wiederhergestellt.',
            'LEAVE_CHAT_CONFIRM': 'Chat verlassen',
            'CHATS_EMPTY_TITLE': 'Keine Chats vorhanden',
            'CHATS_EMPTY_TEXT': 'Sie haben noch keine Chats gestartet. Gehen Sie zur Teilnehmerliste, um mit anderen in Kontakt zu treten.',
            'CHATS_EMPTY_HINT': 'Tippen Sie auf das Benutzer-Symbol, um Teilnehmer zu durchsuchen',
            'LEADS_EMPTY_TITLE': 'Keine geteilten Kontakte',
            'LEADS_EMPTY_TEXT': 'Sie haben noch keine Kontakte geteilt oder erhalten. Teilen Sie Ihre Kontaktdaten mit anderen Teilnehmern in Ihren Chats.',
            'LEADS_EMPTY_HINT': 'Verwenden Sie die Share-Funktion in Ihren Chats, um Kontakte auszutauschen',
            'EXPORT_ALL_CONTACTS': 'Alle Kontakte als .csv exportieren',
            'EDIT_CONTACT': 'Kontakt bearbeiten',
            'PROFILE': 'Profil',
            'SCAN_QR_CODE_LEAD': 'QR-Code scannen',
            'SCAN_QR_POSITION': 'Positionieren Sie den QR-Code im Rahmen',
            'SCAN_QR_INITIALIZING': 'Kamera wird initialisiert...',
            'SCAN_QR_READY': 'Bereit zum Scannen',
            'SCAN_QR_SUCCESS': 'QR-Code gescannt!',
            'MEETINGS_EMPTY_TITLE': 'Keine Meetings geplant',
            'MEETINGS_EMPTY_TEXT': 'Sie haben noch keine Meetings geplant oder erhalten. Planen Sie Meetings mit anderen Teilnehmern in Ihren Chats.',
            'MEETINGS_EMPTY_HINT': 'Verwenden Sie die Meeting-Funktion in Ihren Chats, um Treffen zu vereinbaren',
            'MEETINGS_DESCRIPTION': 'Unten ist eine Liste aller geplanten Meetings aus Ihren Chats',
            'MEETING_UPDATED': 'Aktualisiert',
            'MEETING_ACCEPT': 'Annehmen',
            'MEETING_REJECT': 'Ablehnen',
            'MEETING_ACCEPTED': 'Angenommen',
            'MEETING_REJECTED': 'Abgelehnt',
            'MEETING_PENDING': 'Ausstehend',
            'CALENDAR_EXPORT_TITLE': 'Events in Kalender exportieren',
            'CALENDAR_EXPORT_DESCRIPTION': 'Wählen Sie Events aus, die Sie zu Ihrem Kalender hinzufügen möchten. Jedes Event öffnet die Kalender-App Ihres Geräts.',
            'CALENDAR_EXPORT_ADD': 'Hinzufügen',
            'CALENDAR_EXPORT_ADDED': 'Hinzugefügt',
            'CALENDAR_EXPORT_CLOSE': 'Schließen',
            'CALENDAR_EXPORT_UNTITLED': 'Unbenanntes Event',
            'CALENDAR_EXPORT_ERROR': 'Event konnte nicht zum Kalender hinzugefügt werden. Bitte versuchen Sie es erneut.',
            'EXPORT_GENERATING': 'Ihr Export wird erstellt. Bitte warten Sie, bis der Vorgang abgeschlossen ist.',
            'PDF_EXPORT_ERROR': 'PDF konnte nicht erstellt werden',
            'NO_EVENTS_TO_EXPORT': 'Keine Events zum Exportieren. Bitte fügen Sie zuerst einige Favoriten hinzu.',
        },
        
        'en': {
            'INTERACTIVE_HEADER': 'Q&A',
            'FAVS': 'Favorites',
            'NOTES': 'Notes',
            'MY_NOTE': 'My Note',
            'PRESENTATION': 'Presentation',
            'MAIL_EXPORT': 'Export to Mail',
            'LOGIN': 'LOG IN',
            'IMPRINT': 'Imprint',
            'ABOUT': 'About',
            'PRIVACY': 'Privacy',
            'SUPPORT': 'Support',
            'SEARCH': 'Search',
            'ADD_FAVORITE': 'Favorite',
            'RM_FAVORITE': 'Saved',
            'SAVE_CALENDAR': 'Save to calendar',
            'CHAIR_HEADER': 'Chair',
            'SPEAKER_HEADER': 'Presenter',
            'PRESENTATION_HEADER': 'Presentations',
            'PERSON_SESSION_HEADER': 'Sessions of this person',
            'EVALUATE': 'Evaluate',
            'SESSION_HEADER': 'Session',
            'SESSION_HEADER_ALSO': 'Also presented in session',
            'NOW_HINT': 'No session running now or in the next 15 minutes',
            'SESSIONS_EMPTY_TITLE': 'No Live Sessions',
            'SESSIONS_EMPTY_TEXT': 'There are currently no sessions running or starting in the next 15 minutes. Please check back later or view the full program.',
            'SESSIONS_EMPTY_HINT': 'Pull down to refresh or check the program schedule',
            'GO_TO_PROGRAM': 'View Full Program',
            'FAVORITES_EMPTY_TITLE': 'No Favorites Yet',
            'FAVORITES_EMPTY_TEXT': 'You have not added any favorites so far. You can add sessions, presentations, persons, and exhibitors to your favorites.',
            'FAVORITES_EMPTY_HINT': 'Look for the heart icon to add items to your favorites',
            'NOTES_EMPTY_TITLE': 'No Notes Yet',
            'NOTES_EMPTY_TEXT': 'You have not added any notes so far. You can add notes to sessions, presentations, persons, and exhibitors.',
            'NOTES_EMPTY_HINT': 'Look for the note icon to add personal notes to items',
            'SESSION_TYPES_TITLE': 'Session Types',
            'SESSION_TYPES_SUBTITLE': 'Explore different types of sessions available',
            'SESSION_TYPES_EMPTY_TITLE': 'No Session Types Available',
            'SESSION_TYPES_EMPTY_TEXT': 'There are currently no session types to display.',
            'SESSION_THEMES_TITLE': 'Session Themes',
            'SESSION_THEMES_SUBTITLE': 'Explore different themes',
            'SESSION_THEMES_EMPTY_TITLE': 'No Themes Available',
            'SESSION_THEMES_EMPTY_TEXT': 'There are currently no themes to display.',
            'MAPS_TITLE': 'Maps & Floor Plans',
            'MAPS_SUBTITLE': 'Navigate the venue with ease',
            'MAPS_EMPTY_TITLE': 'No Maps Available',
            'MAPS_EMPTY_TEXT': 'There are currently no maps or floor plans to display.',
            'MAPS_EMPTY_HINT': 'Maps will be added as they become available',
            'VIEW_MAP': 'View Map',
            'SESSION_FILTER_NO_RESULTS_TITLE': 'No Sessions Found',
            'SESSION_FILTER_NO_MATCHES_TITLE': 'No Sessions Match Your Filters',
            'SESSION_FILTER_SEARCH_TEXT': 'We couldn\'t find any sessions matching your search',
            'SESSION_FILTER_FILTER_TEXT': 'Try adjusting your filter selections to see more sessions.',
            'SESSION_FILTER_SEARCH_HINT': 'Try searching for a different term or remove filters',
            'SESSION_FILTER_COUNT_HINT': 'session type currently filtered out',
            'SESSION_FILTER_COUNT_HINT_PLURAL': 'session types currently filtered out',
            'PERSONS_NO_RESULTS_TITLE': 'No Persons Found',
            'PERSONS_NO_MATCHES_TITLE': 'No Persons for This Letter',
            'PERSONS_SEARCH_TEXT': 'We couldn\'t find any persons matching your search',
            'PERSONS_LETTER_TEXT': 'There are no persons whose names start with this letter.',
            'PERSONS_SEARCH_HINT': 'Try searching for a different term',
            'PERSONS_LETTER_HINT': 'Choose a different letter or search for a specific name',
            'SPONSORS_NO_RESULTS_TITLE': 'No Sponsors Found',
            'SPONSORS_SEARCH_TEXT': 'We couldn\'t find any sponsors matching your search',
            'SPONSORS_SEARCH_HINT': 'Try searching for a different term or check your spelling',
            'EXHIBITORS_NO_RESULTS_TITLE': 'No Exhibitors Found',
            'EXHIBITORS_SEARCH_TEXT': 'We couldn\'t find any exhibitors matching your search',
            'EXHIBITORS_SEARCH_HINT': 'Try searching for a different term or check your spelling',
            'CLEAR_FILTERS': 'Clear filters',
            'SORT_BY_BOOTH': 'Sort by Booth',
            'SORT_ALPHABETICALLY': 'Sort alphabetically',
            'SESSION': 'Session',
            'SESSIONS': 'Sessions',
            'SECTION_SESSION': 'Sessions',
            'SECTION_PRESENTATION': 'Presentations',
            'SECTION_PERSON': 'Persons',
            'SECTION_ABSTRACTS': 'Abstracts',
            'SECTION_INDUSTRY': 'Industry',
            'NEWS_HINT': 'For now, there are no messages yet. Please come back later.',
            'COMMENTS': 'Comments',
            'INTERACTIVE': 'Questions',
            'NO_RESULT_FIRST': 'We\'re sorry, we didn\'t find a search result for "',
            'NO_RESULT_SECOND': '". Please try again.',
            'SEARCH_START_TITLE': 'Start Your Search',
            'SEARCH_START_TEXT': 'Enter a search term above to find sessions, presentations, persons, abstracts, and industry content.',
            'SEARCH_START_HINT': 'Try searching for topics, speaker names, or company names',
            'SEARCH_NO_RESULTS_TITLE': 'No Results Found',
            'SEARCH_NO_RESULTS_HINT': 'Try different keywords or check your spelling',
            'LOAD_COMMENTS': 'Loading comments',
            'ENTER_COMMENT': 'Please enter your comment',
            'NO_FORUM': 'No comments activated',
            'FORUM_LOGIN': 'Please login to send comments',
            'FORUM_SEND': 'Send',
            'VOTING_LOGIN': 'Please login to participate in votings',
            'VOTING_CONTROVERSIAL': 'Controversial Question',
            'VOTE_ALREADY_SENT': 'You´ve already voted',
            'VOTE_THANK': 'Thank you for your vote',
            'TOTAL_VOTES': 'Total votes',
            'MY_QUESTION': 'My question',
            'ENTER_QUESTION': 'Please enter your question',
            'QUESTION_SEND': ' Send',
            'SEND_AS': 'Send as ',
            'QUESTIONS_AUDIENCE': 'Questions from the audience',
            'DATA_UPDATE': 'Data Update',
            'PERSONAL_ACCOUNT': 'Mein Account',
            'ACCOUNT_EDIT': 'Edit Profile',
            'ACCOUNT_EMAIL': 'Email',
            'ACCOUNT_PHONE': 'Phone',
            'PHONE_NOT_SHARED': 'not shared',
            'ACCOUNT_ADDRESS': 'Address',
            'ACCOUNT_COUNTRY': 'Country',
            'ACCOUNT_RESET': 'Reset application data',
            'RESET_HEADER': 'Reset application data',
            'RESET_TEXT': 'This will re-initialize the whole application. Are you sure?',
            'MY_PROFILE': 'My Profile',
            'MY_CONGRESS': 'My Congress',
            'LOGOUT': 'Log Out',
            'VISIT_BOOTH': 'Visit our booth',
            'CONTACT_US': 'Contact us',
            'ABOUT_US': 'About us',
            'RES_CENTRE': 'Resource Center',
            'EXHIBITORS': 'Exhibitors',
            'NO_BIOGRAPHY': 'This person has no biography',
            'ADD_NOTE': 'Add Note',
            'EDIT_NOTE': 'Edit Note',
            'DELETE_NOTE': 'Delete Note',
            'SAVE_NOTE': 'Save Note',
            'CLOSE': 'Close',
            'ALL': 'All',
            'RECOMMENDATION_REASON_TITLE': 'Recommendation System',
            'RECOMMENDATION_REASON_SESSION': 'Sessions are recommended based on your favorites.',
            'BOOTHS': 'Booths',
            'NO_BOOTHS': 'This Sponsor has no Booths',
            'WEBSITE': 'Website',
            'SPECIAL_THANKS': 'Special Thanks',
            'NO_NEWS': 'There are no Messages right now.',
            'NEWS_EMPTY_TITLE': 'No News Available',
            'NEWS_EMPTY_TEXT': 'There are currently no news updates or announcements to display. Check back later for the latest information.',
            'NEWS_EMPTY_HINT': 'Pull down to refresh and check for new updates',
            'COMING_SOON_TITLE': 'Coming Soon',
            'COMING_SOON_TEXT': 'New content will be available here soon.',
            'COMING_SOON_HINT': 'Check back later for updates!',
            'SHOW_MAP': 'Show on map',
            'SESSION_NO_ACCESS': 'Your registration does not include access to this content.',
            'EVALUATION_NOT_ACTIVE': 'Evaluation is not active for this session',
            'PRESENTATION_ABSTRACT': 'Abstract',
            'MORE_INFORMATION': 'More Information',
            'INITIALIZING_DATA': 'Initializing data',
            'CHECKING_DATA': 'Checking data',
            'DELETE_ACCOUNT': 'Delete my account',
            'PERS_ACCOUNT': 'Personal account',
            'EXHIBITOR_WEBSITE': 'Visit our Website',
            'DOWNLOAD': 'Downloading',
            'CALENDAR_SAVE': 'Event saved succesfully',
            'CALENDAR_SAVE_ERROR': 'Event could not be saved. Error: ',
            'SCANS_TITLE': 'Scanned Sessions',
            'PERSON_SESSIONS_TITLE': 'Involved in these sessions',
            'PERSON_PRESENTATIONS_TITLE': 'Involved in these presentations',
            'TYPE_MESSAGE': 'Type your message',
            'OPEN_DESCRIPTION': 'Read description',
            'SESSION_DESCRIPTION': 'Session description',
            'ROOM_NO_ACCESS': 'Your registration does not include access to this content.',
            'QANDA_RELOAD_AUDIO': 'If you hear an echo or you cannot see the stream or the Q&A, please refresh this page or press F5.',
            'QANDA_RELOAD_VIDEO': 'If you cannot see the stream, please refresh this page.',
            'STREAM_START_SOON': 'Programme starting soon',
            'TAB_DETAILS': 'Details',
            'TAB_SPEAKERS': 'Speakers',
            'TAB_PRESENTATIONS': 'Presentations',
            'NO_ADDITIONAL_DETAILS': 'No additional details available',
            'CHAT_PARTICIPANTS': 'Participants',
            'CHAT_MY_CHATS': 'My Chats',
            'CHAT_RECOMMENDATIONS': 'Networking Recommendations',
            'LEADS_MY_LEADS': 'My Contacts',
            'MEETINGS_MY_MEETINGS': 'My Meetings',
            'CHATS_LOADING': 'Loading Chats...',
            'FAVORITES_SYNC': 'Syncing favorites...',
            'LOG_IN_QUESTION': 'Do you want to log in?',
            'LOG_OUT_QUESTION': 'Do you want to log out?',
            'YES_ANSWER': 'Yes',
            'NO_ANSWER': 'No',
            'START_CHAT': 'Chat',
            'RECOMMENDATIONS': 'Recommendations',
            'SESSION_RECOMMENDATIONS': 'Session recommendations',

            'RECOMMENDATIONS_POPUP': 'This session is recommended for you based on: ',
            'RECOMMENDATIONS_USER_POPUP': 'This user is recommended for you based on: ',
            'RECOMMENDATIONS_LOGIN': 'Please log in to see recommended sessions based on your profile.',
            'RECOMMENDED_FOR': 'Recommended for: ',
            'SCHEDULE_MEETING_BUTTON': 'Schedule meeting',
            'NETWORKING_SCHEDULE_BUTTON': 'Schedule',
            'NETWORKING_SHARE_CONTACT_BUTTON': 'Share Contact',
            'QR_CODE_TITLE': 'Click or scan QR Code',
            'QR_CODE_SUBTITLE': 'Add to Contacts',
            'SAVE_CONTACT_BUTTON': 'Save as contact',
            'SAVE_CONTACT_SUCCESS': 'The contact has been saved to your device',
            'COMPLETE_MEETING_REQUEST': 'Please fill all the fields of the request.',
            'SHARE_PROFILE': 'Share your contact data',
            'SHARE_PROFILE_WITH': 'Share your contact data with ',
            'SHARE_PROFILE_DESCRIPTION': 'By using this feature, you can share your contact details with ',
            'SHARE_PROFILE_PROMPT': 'Enter or edit your contact data here: ',
            'YOUR_PROFILE': 'Your Profile',
            'SHARING_WITH': 'Sharing with',
            'ROOM_NOT_LINKED_TITLE': 'Room Not Linked',
            'ROOM_NOT_LINKED_TEXT': 'This room is not currently linked to the floor plan.',
            'ROOM_NOT_LINKED_HINT': 'Please try again later or select a different room.',
            'NO_RECOMMENDATIONS': 'Update your profile information to receive recommendations',
            'LOGIN_REQUIRED': 'Login required',
            'LOGIN_REQUIRED_MSG': 'Login is required for most features of this app',
            'AUTHENTICATION_REQUIRED': 'Authentication Required',
            'LOGIN_HINT': 'You need to be logged in to access the Social Wall',
            'SOCIAL_WALL': 'Social Wall',
            'SOCIAL_WALL_LOGIN_HINT': 'Log in in order to access the social wall features in this app!',
            'NEW_MEETING_REQUEST': 'New meeting request from',
            'DATE_MEETING_REQUEST': 'Date',
            'LOCATION_MEETING_REQUEST': 'Location',
            'SUBJECT_MEETING_REQUEST': 'Subject',
            'DETAILS_MEETING_REQUEST': 'Details',
            'MORE_INFORMATION': 'More Information',
            'SYNC_HEADER': 'Additional data available for download',
            'SYNC_MESSAGE': 'Do you want to load {size} {unit} additional data?',
            'SYNC_UNPACK_HEADER': 'Additional data has to be unpacked',
            'SYNC_UNPACK_MESSAGE': 'Click OK to unpack {size} {unit} additional data',
            'CANCEL': 'Cancel',
            'OK': 'OK',
            'QR_SHARE_PROFILE': 'Share profile',
            'QR_SHARE_PROFILE_SUBTITLE': 'Other people can scan your QR code to check your profile in the app',

            'UP_TO_DATE': 'Application is now up to date',
            'NEW_VERSION_AVAILABLE': 'A new version is available',
            'NEW_VERSION_IN_STORE': 'A new version is available in the App Store',
            'LEAVE_CHAT_HEADER': 'Leave Chat',
            'LEAVE_CHAT_MESSAGE': 'By leaving the chat you will not be visible to any other participants anymore. All your chats, shared contacts and meetings will be deleted (for yourself and your chat partners). You can join the chat at a later stage again if you want but the information will not be restored.',
            'LEAVE_CHAT_CONFIRM': 'Leave Chat',
            'CHATS_EMPTY_TITLE': 'No Chats Yet',
            'CHATS_EMPTY_TEXT': 'You haven\'t started any conversations yet. Go to the participants list to connect with others.',
            'CHATS_EMPTY_HINT': 'Tap the users icon to browse participants',
            'LEADS_EMPTY_TITLE': 'No Shared Contacts',
            'LEADS_EMPTY_TEXT': 'You haven\'t shared or received any contacts yet. Share your contact details with other participants in your chats.',
            'LEADS_EMPTY_HINT': 'Use the share feature in your chats to exchange contacts',
            'EXPORT_ALL_CONTACTS': 'Export all contacts as .csv',
            'EDIT_CONTACT': 'Edit Contact',
            'PROFILE': 'Profile',
            'SCAN_QR_CODE_LEAD': 'Scan QR Code',
            'SCAN_QR_POSITION': 'Position the QR code within the frame',
            'SCAN_QR_INITIALIZING': 'Initializing camera...',
            'SCAN_QR_READY': 'Ready to scan',
            'SCAN_QR_SUCCESS': 'QR Code Scanned!',
            'MEETINGS_EMPTY_TITLE': 'No Meetings Scheduled',
            'MEETINGS_EMPTY_TEXT': 'You haven\'t scheduled or received any meeting requests yet. Schedule meetings with other participants in your chats.',
            'MEETINGS_EMPTY_HINT': 'Use the meeting feature in your chats to arrange meetings',
            'MEETINGS_DESCRIPTION': 'Below is a list of all scheduled meetings originating from your chats',
            'MEETING_UPDATED': 'Updated',
            'MEETING_ACCEPT': 'Accept',
            'MEETING_REJECT': 'Reject',
            'MEETING_ACCEPTED': 'Accepted',
            'MEETING_REJECTED': 'Rejected',
            'MEETING_PENDING': 'Pending',
            'CALENDAR_EXPORT_TITLE': 'Export Events to Calendar',
            'CALENDAR_EXPORT_DESCRIPTION': 'Select events to add to your calendar. Each event will open your device\'s calendar app.',
            'CALENDAR_EXPORT_ADD': 'Add',
            'CALENDAR_EXPORT_ADDED': 'Added',
            'CALENDAR_EXPORT_CLOSE': 'Close',
            'CALENDAR_EXPORT_UNTITLED': 'Untitled Event',
            'CALENDAR_EXPORT_ERROR': 'Failed to add event to calendar. Please try again.',
            'EXPORT_GENERATING': 'Your export is being generated. Please wait until finished.',
            'PDF_EXPORT_ERROR': 'Failed to generate PDF',
            'NO_EVENTS_TO_EXPORT': 'No events to export. Please add some favorites first.',
        },
        'fr': {
            'INTERACTIVE_HEADER': 'Q&A',
            'FAVS': 'Favoris',
            'NOTES': 'Notes',
            'MY_NOTE': 'Ma Note:',
            'PRESENTATION': 'Présentation',
            'MAIL_EXPORT': 'Exporter vers e-mail',
            'LOGIN': 'Connecter',
            'IMPRINT': 'Impression',
            'ABOUT': 'À propos',
            'PRIVACY': 'Confidentialité',
            'SUPPORT': 'Support',
            'SEARCH': 'Recherche',
            'ADD_FAVORITE': 'Ajouter aux favoris',
            'RM_FAVORITE': 'Supprimer des favoris',
            'SAVE_CALENDAR': 'Enregistrer dans le calendrier',
            'CHAIR_HEADER': 'Moderation',
            'SPEAKER_HEADER': 'Speaker',
            'PRESENTATION_HEADER': 'Présentation',
            'PERSON_SESSION_HEADER': 'Sessions de cette personne',
            'EVALUATE': 'Evaluez',
            'SESSION_HEADER': 'Session ',
            'SESSION_HEADER_ALSO': 'Également présenté en session',
            'NOW_HINT': 'Pas de session en cours ni dans les 15 prochaines minutes dans les 15 prochaines minutes',
            'SESSIONS_EMPTY_TITLE': 'Aucune session en direct',
            'SESSIONS_EMPTY_TEXT': 'Il n\'y a actuellement aucune session en cours ou qui commence dans les 15 prochaines minutes. Veuillez revenir plus tard ou consulter le programme complet.',
            'SESSIONS_EMPTY_HINT': 'Tirez vers le bas pour actualiser ou vérifiez le programme',
            'GO_TO_PROGRAM': 'Voir le programme complet',
            'FAVORITES_EMPTY_TITLE': 'Aucun favori pour le moment',
            'FAVORITES_EMPTY_TEXT': 'Vous n\'avez encore ajouté aucun favori. Vous pouvez ajouter des sessions, présentations, personnes et entreprises à vos favoris.',
            'FAVORITES_EMPTY_HINT': 'Recherchez l\'icône de cœur pour ajouter des éléments à vos favoris',
            'NOTES_EMPTY_TITLE': 'Aucune note pour le moment',
            'NOTES_EMPTY_TEXT': 'Vous n\'avez encore ajouté aucune note. Vous pouvez ajouter des notes aux sessions, présentations, personnes et entreprises.',
            'NOTES_EMPTY_HINT': 'Recherchez l\'icône de note pour ajouter des notes personnelles aux éléments',
            'SESSION_TYPES_TITLE': 'Types de sessions',
            'SESSION_TYPES_SUBTITLE': 'Explorez les différents types de sessions disponibles',
            'SESSION_TYPES_EMPTY_TITLE': 'Aucun type de session disponible',
            'SESSION_TYPES_EMPTY_TEXT': 'Il n\'y a actuellement aucun type de session à afficher.',
            'SESSION_THEMES_TITLE': 'Thèmes des sessions',
            'SESSION_THEMES_SUBTITLE': 'Explorez différents thèmes',
            'SESSION_THEMES_EMPTY_TITLE': 'Aucun thème disponible',
            'SESSION_THEMES_EMPTY_TEXT': 'Il n\'y a actuellement aucun thème à afficher.',
            'MAPS_TITLE': 'Cartes & Plans',
            'MAPS_SUBTITLE': 'Naviguez facilement dans le lieu',
            'MAPS_EMPTY_TITLE': 'Aucune carte disponible',
            'MAPS_EMPTY_TEXT': 'Il n\'y a actuellement aucune carte ou plan à afficher.',
            'MAPS_EMPTY_HINT': 'Les cartes seront ajoutées dès qu\'elles seront disponibles',
            'VIEW_MAP': 'Voir la carte',
            'SESSION_FILTER_NO_RESULTS_TITLE': 'Aucune session trouvée',
            'SESSION_FILTER_NO_MATCHES_TITLE': 'Aucune session ne correspond à vos filtres',
            'SESSION_FILTER_SEARCH_TEXT': 'Nous n\'avons trouvé aucune session correspondant à votre recherche',
            'SESSION_FILTER_FILTER_TEXT': 'Essayez d\'ajuster vos sélections de filtres pour voir plus de sessions.',
            'SESSION_FILTER_SEARCH_HINT': 'Essayez de rechercher un terme différent ou supprimez les filtres',
            'SESSION_FILTER_COUNT_HINT': 'type de session actuellement filtré',
            'SESSION_FILTER_COUNT_HINT_PLURAL': 'types de sessions actuellement filtrés',
            'PERSONS_NO_RESULTS_TITLE': 'Aucune personne trouvée',
            'PERSONS_NO_MATCHES_TITLE': 'Aucune personne pour cette lettre',
            'PERSONS_SEARCH_TEXT': 'Nous n\'avons trouvé aucune personne correspondant à votre recherche',
            'PERSONS_LETTER_TEXT': 'Il n\'y a aucune personne dont le nom commence par cette lettre.',
            'PERSONS_SEARCH_HINT': 'Essayez de rechercher un terme différent',
            'PERSONS_LETTER_HINT': 'Choisissez une lettre différente ou recherchez un nom spécifique',
            'SPONSORS_NO_RESULTS_TITLE': 'Aucun sponsor trouvé',
            'SPONSORS_SEARCH_TEXT': 'Nous n\'avons trouvé aucun sponsor correspondant à votre recherche',
            'SPONSORS_SEARCH_HINT': 'Essayez de rechercher un terme différent ou vérifiez l\'orthographe',
            'EXHIBITORS_NO_RESULTS_TITLE': 'Aucun exposant trouvé',
            'EXHIBITORS_SEARCH_TEXT': 'Nous n\'avons trouvé aucun exposant correspondant à votre recherche',
            'EXHIBITORS_SEARCH_HINT': 'Essayez de rechercher un terme différent ou vérifiez l\'orthographe',
            'CLEAR_FILTERS': 'Effacer les filtres',
            'SORT_BY_BOOTH': 'Trier par stand',
            'SORT_ALPHABETICALLY': 'Trier par ordre alphabétique',
            'SESSION': 'Session',
            'SESSIONS': 'Sessions',
            'SECTION_SESSION': 'Sessions',
            'SECTION_PRESENTATION': 'Présentation',
            'SECTION_PERSON': 'Personne',
            'SECTION_ABSTRACTS': 'Abstract',
            'SECTION_INDUSTRY': 'Industrie',
            'NEWS_HINT': 'Pas de message pour le moment.',
            'COMMENTS': 'Commentaires',
            'INTERACTIVE': 'Questions',
            'NO_RESULT_FIRST': 'Désolé pas résultat de recherche',
            'NO_RESULT_SECOND': 'Veuillez essayer à nouveau',
            'SEARCH_START_TITLE': 'Commencez votre recherche',
            'SEARCH_START_TEXT': 'Entrez un terme de recherche ci-dessus pour trouver des sessions, des présentations, des personnes, des résumés et du contenu industriel.',
            'SEARCH_START_HINT': 'Essayez de rechercher des sujets, des noms de conférenciers ou des noms d\'entreprises',
            'SEARCH_NO_RESULTS_TITLE': 'Aucun résultat trouvé',
            'SEARCH_NO_RESULTS_HINT': 'Essayez des mots-clés différents ou vérifiez votre orthographe',
            'LOAD_COMMENTS': 'En cours, veuillez patienter',
            'ENTER_COMMENT': 'Veuillez saisir votre commentaire',
            'NO_FORUM': 'Pas de commentaire activé',
            'FORUM_LOGIN': 'Veuillez vous connecter pour ajouter vos commentaires',
            'FORUM_SEND': 'Envoyer',
            'VOTING_LOGIN': 'Veuillez vous connecter pour voter',
            'VOTING_CONTROVERSIAL': 'Question controversée ',
            'VOTE_ALREADY_SENT ': 'Vous avez déjà voté',
            'VOTE_THANK': 'Merci pour votre vote',
            'TOTAL_VOTES': 'Nombre total de votes',
            'MY_QUESTION': 'Ma question',
            'ENTER_QUESTION': 'Veuillez saisir votre question',
            'QUESTION_SEND': 'Envoyer',
            'SEND_AS': 'Envoyer comme',
            'QUESTIONS_AUDIENCE': "Question de l'assemblée",
            'DATA_UPDATE': 'Mettre à jour',
            'PERSONAL_ACCOUNT': 'Mon compte',
            'ACCOUNT_EDIT': 'Modifier le compte',
            'ACCOUNT_EMAIL': 'E-mail',
            'ACCOUNT_PHONE': 'Téléphoner',
            'PHONE_NOT_SHARED': 'non partagé',
            'ACCOUNT_ADDRESS': 'Adresse',
            'ACCOUNT_COUNTRY': 'Pays',
            'ACCOUNT_RESET': 'Réinitialiser l\'application',
            'RESET_HEADER': 'Réinitialiser les données d\'application',
            'RESET_TEXT': 'Cela réinitialisera toute l\'application. Êtes-vous sûr ?',
            'MY_PROFILE': 'Mon profil',
            'MY_CONGRESS': 'Mon congrès',
            'LOGOUT': 'Se déconnecter',
            'VISIT_BOOTH': 'Visitez notre stand',
            'CONTACT_US': 'Nous contacter',
            'ABOUT_US': 'À propos de nous',
            'RES_CENTRE': 'Centre de ressources',
            'EXHIBITORS': 'Expositions',
            'NO_BIOGRAPHY': 'Cette personne n\'a pas de biographie',
            'ADD_NOTE': 'Ajouter une note',
            'EDIT_NOTE': 'Modifier la note',
            'DELETE_NOTE': 'Supprimer la note',
            'SAVE_NOTE': 'Enregistrer la Note',
            'CLOSE': 'Fermer',
            'ALL': 'Tous',
            'RECOMMENDATION_REASON_TITLE': 'Système de recommandation',
            'RECOMMENDATION_REASON_SESSION': 'Les sessions sont recommandées en fonction de vos favoris.',
            'BOOTHS': 'Stand',
            'NO_BOOTHS': 'Ce sponsor n\'a pas de stand',
            'WEBSITE': 'Page web',
            'SPECIAL_THANKS': 'Remerciement Spécial',
            'NO_NEWS': 'Il n\'y a aucun message pour le moment.',
            'NEWS_EMPTY_TITLE': 'Aucune nouvelle disponible',
            'NEWS_EMPTY_TEXT': 'Il n\'y a actuellement aucune mise à jour de nouvelles ou d\'annonces à afficher. Revenez plus tard pour les dernières informations.',
            'NEWS_EMPTY_HINT': 'Tirez vers le bas pour actualiser et vérifier les nouvelles mises à jour',
            'COMING_SOON_TITLE': 'Bientôt disponible',
            'COMING_SOON_TEXT': 'De nouveaux contenus seront bientôt disponibles ici.',
            'COMING_SOON_HINT': 'Revenez plus tard pour les mises à jour!',
            'SHOW_MAP': 'Emplacement',
            'SESSION_NO_ACCESS': ' Votre inscription n\'inclut pas l\'accès à ce contenu.',
            'EVALUATION_NOT_ACTIVE': 'L\'évaluation n\'est pas active pour cette session',
            'PRESENTATION_ABSTRACT': 'Abstract',
            'MORE_INFORMATION': 'Plus d\'informations',
            'INITIALIZING_DATA': 'Initialisation des données',
            'CHECKING_DATA': 'Vérification des données',
            'DELETE_ACCOUNT': 'Supprimer mon compte',
            'PERS_ACCOUNT': 'Compte personnel',
            'EXHIBITOR_WEBSITE': 'Visitez notre site Internet',
            'DOWNLOAD': 'Télécharger',
            'CALENDAR_SAVE': 'Session enregistrée avec succès',
            'CALENDAR_SAVE_ERROR': 'La session n\'a pas été enregistrée. Erreur:',
            'SCANS_TITLE': 'Sessions Scannées',
            'PERSON_SESSIONS_TITLE': 'Participant à ces sessions',
            'PERSON_PRESENTATIONS_TITLE': 'Participant à ces présentations',
            'TYPE_MESSAGE': 'Écrivez ici',
            'OPEN_DESCRIPTION': 'Lis la description',
            'SESSION_DESCRIPTION': 'Descriptif de la séance',
            'ROOM_NO_ACCESS': 'Your registration does not include access to this content.',
            'QANDA_RELOAD_AUDIO': 'If you hear an echo or you cannot see the stream or the Q&A, please refresh this page or press F5.',
            'QANDA_RELOAD_VIDEO': 'If you cannot see the stream, please refresh this page.',
            'STREAM_START_SOON': 'Le programme commence bientôt',
            'TAB_DETAILS': 'Détails',
            'TAB_SPEAKERS': 'Intervenants',
            'TAB_PRESENTATIONS': 'Présentations',
            'NO_ADDITIONAL_DETAILS': 'Aucun détail supplémentaire disponible',
            'CHAT_PARTICIPANTS': 'Participants',
            'CHAT_MY_CHATS': 'Mes Chats',
            'CHAT_RECOMMENDATIONS': 'Networking Recommandations',
            'LEADS_MY_LEADS': 'Mes Contacts',
            'MEETINGS_MY_MEETINGS': 'Mes Réunions',
            'CHATS_LOADING': 'Chargement des Chats',
            'FAVORITES_SYNC': 'Favorits Sync...',
            'LOG_IN_QUESTION': 'Do you want to log in?',
            'LOG_OUT_QUESTION': 'Do you want to log out?',
            'YES_ANSWER': 'Oui',
            'NO_ANSWER': 'Non',
            'START_CHAT': 'Chat',
            'RECOMMENDATIONS': 'Recommandations',
            'SESSION_RECOMMENDATIONS': 'Séances recommandées',

            'RECOMMENDATIONS_POPUP': 'Ces sessions vous sont recommandées en fonction de votre pays, de votre pratique et de vos rôles.',
            'RECOMMANDATIONS USER POPUP' : 'Cette personne vous est recommandée en fonction de : ',
            'RECOMMENDATIONS_LOGIN': 'Veuillez vous connecter pour voir les sessions recommandées en fonction de votre profil',
            'RECOMMENDED_FOR': 'Recommandé pour:',
            'SCHEDULE_MEETING_BUTTON': 'Planifier une réunion',
            'NETWORKING_SCHEDULE_BUTTON': 'Planifier',
            'NETWORKING_SHARE_CONTACT_BUTTON': 'Partager Contact',
            'QR_CODE_TITLE': 'Cliquez ou scannez le code QR',
            'QR_CODE_SUBTITLE': 'Ajouter aux contacts',
            'SAVE_CONTACT_BUTTON': 'Enregistrer le contact',
            'SAVE_CONTACT_SUCCESS': 'Veuillez remplir tous les champs de la demande.',
            'SHARE_PROFILE': 'Partagez vos coordonnées',
            'SHARE_PROFILE_WITH': 'Partagez vos coordonnées avec ',
            'SHARE_PROFILE_DESCRIPTION': 'En utilisant cette fonctionnalité, vous partagerez vos coordonnées avec ',
            'SHARE_PROFILE_PROMPT': 'Entrez ou modifiez vos coordonnées ici: ',
            'YOUR_PROFILE': 'Votre Profil',
            'SHARING_WITH': 'Partager avec',
            'ROOM_NOT_LINKED_TITLE': 'Salle non liée',
            'ROOM_NOT_LINKED_TEXT': 'Cette salle n\'est actuellement pas liée au plan d\'étage.',
            'ROOM_NOT_LINKED_HINT': 'Veuillez réessayer plus tard ou sélectionner une autre salle.',
            'NO_RECOMMENDATIONS': 'Mettez à jour les informations de votre profil pour recevoir des recommandations',
            'LOGIN_REQUIRED': 'Connexion requise',
            'LOGIN_REQUIRED_MSG': 'La connexion est requise pour la plupart des fonctionnalités de cette application',
            'AUTHENTICATION_REQUIRED': 'Authentification requise',
            'LOGIN_HINT': 'Vous devez être connecté pour accéder au mur social',
            'SOCIAL_WALL': 'Mur Social',
            'SOCIAL_WALL_LOGIN_HINT': 'Connectez-vous pour accéder aux fonctionnalités du mur social dans cette application!',
            'NEW_MEETING_REQUEST': 'Nouvelle demande de réunion: ',
            'DATE_MEETING_REQUEST': 'Date',
            'LOCATION_MEETING_REQUEST': 'Emplacement',
            'SUBJECT_MEETING_REQUEST': 'Sujet',
            'DETAILS_MEETING_REQUEST': 'Détails',
            'MORE_INFORMATION': 'Plus d\'informations',
            'SYNC_HEADER': 'Données supplémentaires disponibles au téléchargement',
            'SYNC_MESSAGE': 'Voulez-vous charger {size} {unit} de données supplémentaires?',
            'SYNC_UNPACK_HEADER': 'Des données supplémentaires doivent être décompressées',
            'SYNC_UNPACK_MESSAGE': 'Cliquez sur OK pour décompresser {size} {unit} de données supplémentaires',
            'CANCEL': 'Annuler',
            'OK': 'OK',
            'QR_SHARE_PROFILE': 'Partager le profil',
            'QR_SHARE_PROFILE_SUBTITLE': 'D\'autres personnes peuvent scanner votre code QR pour consulter votre profil dans l\'application',

            'UP_TO_DATE': 'L\'application est à jour',
            'NEW_VERSION_AVAILABLE': 'Une nouvelle version est disponible',
            'NEW_VERSION_IN_STORE': 'Une nouvelle version est disponible dans l\'App Store',
            'LEAVE_CHAT_HEADER': 'Quitter le chat',
            'LEAVE_CHAT_MESSAGE': 'En quittant le chat, vous ne serez plus visible pour les autres participants. Tous vos chats, contacts partagés et réunions seront supprimés (pour vous et vos partenaires de chat). Vous pouvez rejoindre le chat ultérieurement si vous le souhaitez, mais les informations ne seront pas restaurées.',
            'LEAVE_CHAT_CONFIRM': 'Quitter le chat',
            'CHATS_EMPTY_TITLE': 'Aucun chat pour le moment',
            'CHATS_EMPTY_TEXT': 'Vous n\'avez pas encore commencé de conversations. Accédez à la liste des participants pour vous connecter avec d\'autres personnes.',
            'CHATS_EMPTY_HINT': 'Appuyez sur l\'icône des utilisateurs pour parcourir les participants',
            'LEADS_EMPTY_TITLE': 'Aucun contact partagé',
            'LEADS_EMPTY_TEXT': 'Vous n\'avez pas encore partagé ou reçu de contacts. Partagez vos coordonnées avec d\'autres participants dans vos chats.',
            'LEADS_EMPTY_HINT': 'Utilisez la fonction de partage dans vos chats pour échanger des contacts',
            'EXPORT_ALL_CONTACTS': 'Exporter tous les contacts en .csv',
            'EDIT_CONTACT': 'Modifier le contact',
            'PROFILE': 'Profil',
            'SCAN_QR_CODE_LEAD': 'Scanner le code QR',
            'SCAN_QR_POSITION': 'Positionnez le code QR dans le cadre',
            'SCAN_QR_INITIALIZING': 'Initialisation de la caméra...',
            'SCAN_QR_READY': 'Prêt à scanner',
            'SCAN_QR_SUCCESS': 'Code QR scanné!',
            'MEETINGS_EMPTY_TITLE': 'Aucune réunion prévue',
            'MEETINGS_EMPTY_TEXT': 'Vous n\'avez pas encore planifié ou reçu de demandes de réunion. Planifiez des réunions avec d\'autres participants dans vos chats.',
            'MEETINGS_EMPTY_HINT': 'Utilisez la fonction de réunion dans vos chats pour organiser des rencontres',
            'MEETINGS_DESCRIPTION': 'Voici une liste de toutes les réunions planifiées provenant de vos chats',
            'MEETING_UPDATED': 'Mis à jour',
            'MEETING_ACCEPT': 'Accepter',
            'MEETING_REJECT': 'Refuser',
            'MEETING_ACCEPTED': 'Accepté',
            'MEETING_REJECTED': 'Refusé',
            'MEETING_PENDING': 'En attente',
            'CALENDAR_EXPORT_TITLE': 'Exporter les événements vers le calendrier',
            'CALENDAR_EXPORT_DESCRIPTION': 'Sélectionnez les événements à ajouter à votre calendrier. Chaque événement ouvrira l\'application de calendrier de votre appareil.',
            'CALENDAR_EXPORT_ADD': 'Ajouter',
            'CALENDAR_EXPORT_ADDED': 'Ajouté',
            'CALENDAR_EXPORT_CLOSE': 'Fermer',
            'CALENDAR_EXPORT_UNTITLED': 'Événement sans titre',
            'CALENDAR_EXPORT_ERROR': 'Échec de l\'ajout de l\'événement au calendrier. Veuillez réessayer.',
            'EXPORT_GENERATING': 'Votre exportation est en cours de génération. Veuillez patienter jusqu\'à la fin.',
            'PDF_EXPORT_ERROR': 'Échec de la génération du PDF',
            'NO_EVENTS_TO_EXPORT': 'Aucun événement à exporter. Veuillez d\'abord ajouter des favoris.',
}




        }

}

const actions = {
    changeLanguage({state}, lang) {
        state.currentLanguage = lang;
    }

}
const mutations = {}
const getters = {}

export const wordings = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
